module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [(_vm.$route.query.type === 'ecs') ? _c('translate', [_vm._v("Add Host")]) : _vm._e(), _vm._v(" "), (_vm.$route.query.type === 'rds') ? _c('translate', [_vm._v("Add Database")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.selectCluster
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "380px",
      "min-width": "100%"
    },
    attrs: {
      "value-key": "",
      "filterable": ""
    },
    on: {
      "change": _vm.onChangeCluster
    },
    model: {
      value: (_vm.selectedClusterId),
      callback: function($$v) {
        _vm.selectedClusterId = $$v
      },
      expression: "selectedClusterId"
    }
  }, [_vm._l((_vm.clusterList), function(item, index) {
    return _c('el-option', {
      key: index,
      staticStyle: {
        "width": "380px",
        "min-width": "100%"
      },
      attrs: {
        "label": item.name,
        "value": item.project_id
      }
    })
  }), _vm._v(" "), (_vm.clusterList.length < _vm.page.total) ? _c('p', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingMore),
      expression: "loadingMore"
    }],
    staticClass: "loadMore",
    on: {
      "click": _vm.loadMoreCluster
    }
  }, [_c('translate', [_vm._v("Load More")])], 1) : _vm._e()], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.selectInstance
    }
  }, [_c('div', {
    staticClass: "filter-content"
  }, [_c('el-select', {
    staticClass: "fitler-key",
    model: {
      value: (_vm.filter.key),
      callback: function($$v) {
        _vm.filter.key = $$v
      },
      expression: "filter.key"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.name,
      "value": "q_name"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IP",
      "value": "q_ip"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    staticClass: "filter-value",
    attrs: {
      "placeholder": _vm.attrText.input
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onFilter($event)
      }
    },
    model: {
      value: (_vm.filter.value),
      callback: function($$v) {
        _vm.filter.value = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "filter.value"
    }
  }, [_c('el-button', {
    staticClass: "filter-btn",
    on: {
      "click": _vm.onFilter
    },
    slot: "append"
  }, [_c('i', {
    staticClass: "el-icon-search"
  })])], 1)], 1), _vm._v(" "), (_vm.resourceLoading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.resourceLoading),
      expression: "resourceLoading"
    }],
    staticStyle: {
      "height": "100px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.resourceList && _vm.resourceList.length) ? _c('div', {
    staticClass: "select-instance"
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.selectedResourceAll),
      callback: function($$v) {
        _vm.selectedResourceAll = $$v
      },
      expression: "selectedResourceAll"
    }
  }, [_c('translate', [_vm._v("All")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }), _vm._v(" "), _c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: (_vm.selectedResourceIds),
      callback: function($$v) {
        _vm.selectedResourceIds = $$v
      },
      expression: "selectedResourceIds"
    }
  }, _vm._l((_vm.resourceList), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      attrs: {
        "label": item.id
      }
    }, [_vm._v("\n              " + _vm._s(((item.name) + "(" + (item.ip) + ")")) + "\n            ")])
  }))], 1) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$route.query.type === 'ecs' ? _vm.attrText.selectedInstance : _vm.attrText.selectedDatabase
    }
  }, [_c('div', {
    staticClass: "resource-selected"
  }, [(_vm.selectedResourceList.length === 0) ? _c('div', {
    staticClass: "no-select"
  }, [_c('translate', [_vm._v("No resource selected")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.selectedResourceList), function(tag) {
    return _c('el-tag', {
      key: tag.name,
      attrs: {
        "closable": true
      },
      on: {
        "close": function($event) {
          _vm.onCloseTag(tag)
        }
      }
    }, [_vm._v("\n            " + _vm._s(((tag.name) + "/(" + (tag.ip) + ")")) + "\n          ")])
  })], 2)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.selectedResourceList.length === 0
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('translate', [_vm._v("Submit")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs['right-panel'].onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47fcb40a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/model/workgroup-distribute-instance.vue
// module id = 558
// module chunks = 4 5 6